/**
 * Add your config changes here.
 * @module config
 */

import applyItaliaConfig from '@italia/config/italiaConfig';
import '@plone/volto/config';

export default function applyConfig(voltoConfig) {
  let config = applyItaliaConfig(voltoConfig);

  config.settings = {
    ...config.settings,
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Sostenibilità',
      siteSubtitle: 'Ospedali Galliera',
      parentSiteTitle: 'Ente Ospedaliero - Ospedali Galliera di Genova',
      parentSiteURL: 'https://www.galliera.it/',
      subsiteParentSiteTitle: 'Ente Ospedaliero - Ospedali Galliera di Genova',
      arLoginUrl: 'https://bilanciosociale.galliera.it/login',
      arLogoutUrl: 'https://bilanciosociale.galliera.it/logout',
      // DEV SETTING
      // arLoginUrl: 'http://localhost:3000/login',
      // arLogoutUrl: 'http://localhost:3000/logout',
    },
  };

  // config.views = {
  //   ...config.views,
  // };
  // config.widgets = {
  //   ...config.widgets,
  // };

  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    listing_bg_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
    listing_items_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
  };

  config.settings['volto-gdpr-privacy'].defaultPanelConfig.text = {
    it: {
      title: 'Usiamo i cookies',
      description:
        "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. I cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Cambia le impostazioni'. Per saperne di più su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='https://www.galliera.it/20/56/53/54/54' target='_blank'>Cookie Policy.</a>",
    },
  };

  config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical.choices = [
    ...config.settings[
      'volto-gdpr-privacy'
    ].defaultPanelConfig.technical.choices.filter(
      (f) => f.config_key !== 'GANALYTICS',
    ),
  ];

  return config;
}
